/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerSearchResultDto
 */
export interface PartnerSearchResultDto {
    /**
     * 
     * @type {string}
     * @memberof PartnerSearchResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerSearchResultDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerSearchResultDto
     */
    organizationType: PartnerSearchResultDtoOrganizationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerSearchResultDto
     */
    normalizedName: string | null;
}


/**
 * @export
 */
export const PartnerSearchResultDtoOrganizationTypeEnum = {
    Operator: 'Operator',
    Manufacturer: 'Manufacturer',
    Landlord: 'Landlord',
    Oem: 'OEM'
} as const;
export type PartnerSearchResultDtoOrganizationTypeEnum = typeof PartnerSearchResultDtoOrganizationTypeEnum[keyof typeof PartnerSearchResultDtoOrganizationTypeEnum];


/**
 * Check if a given object implements the PartnerSearchResultDto interface.
 */
export function instanceOfPartnerSearchResultDto(value: object): value is PartnerSearchResultDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('organizationType' in value) || value['organizationType'] === undefined) return false;
    if (!('normalizedName' in value) || value['normalizedName'] === undefined) return false;
    return true;
}

export function PartnerSearchResultDtoFromJSON(json: any): PartnerSearchResultDto {
    return PartnerSearchResultDtoFromJSONTyped(json, false);
}

export function PartnerSearchResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerSearchResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'organizationType': json['organizationType'],
        'normalizedName': json['normalizedName'],
    };
}

export function PartnerSearchResultDtoToJSON(json: any): PartnerSearchResultDto {
    return PartnerSearchResultDtoToJSONTyped(json, false);
}

export function PartnerSearchResultDtoToJSONTyped(value?: PartnerSearchResultDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'organizationType': value['organizationType'],
        'normalizedName': value['normalizedName'],
    };
}

